import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";

@Form({title: "Metabase Panel Config"})
export default class MetabasePanelConfig {

	@Input({type: InputType.NUMBER, title: "Resource id"})
	public resourceId: number;

}



// WEBPACK FOOTER //
// ./src/panels/metabase/MetabasePanelConfig.ts